import { useState } from "react";

import { requestTranscription } from "@/api/endpoints/episodes";
import { INSTAGRAM_TITLE, SOURCE, TRANSCRIPTION_STATUS } from "@/constants";
import { useEpisode } from "@/containers/Episode/context";
import { useMessages } from "@/containers/Messages/MessageContext";
import { useEpisodes } from "@/contexts/EpisodesContext";
import { FEATURE } from "@/features";
import { useHasFeature } from "@/hooks/useHasFeature";

const TranscribeEpisode: React.FunctionComponent<{
  component: React.ElementType;
}> = ({ component: Component, ...rest }) => {
  const {
    episode_id,
    episode_uuid,
    episode_has_transcript,
    episode_transcript_status,
    title,
    is_text_source,
    source,
  } = useEpisode();

  const [loading, setLoading] = useState(false);
  const { danger, success } = useMessages();
  const { patchEpisode } = useEpisodes();

  const handleRequestTranscript = (e: MouseEvent) => {
    e.preventDefault();

    requestTranscription(episode_id.toString())
      .then(() => {
        setLoading(true);
        patchEpisode({
          episode_uuid,
          episode_transcript_status: TRANSCRIPTION_STATUS.QUEUED,
        });
        success({
          title: "",
          message: L.CUSTOMERS_REQUEST_TRANSCRIBE_SUCCESS_MESSAGE,
        });
      })
      .catch(() => {
        setLoading(false);
        danger({
          title: L.CUSTOMERS_SEARCH_500_ERROR_TITLE,
          message: L.CUSTOMERS_SEARCH_500_ERROR_MESSAGE,
        });
      });
  };

  const transcriptionInProgress =
    episode_transcript_status === TRANSCRIPTION_STATUS.QUEUED;

  const isTiktokOrInstagramOrNonText =
    !is_text_source ||
    source === SOURCE.TIKTOK ||
    (source == SOURCE.INSTAGRAM &&
      (title === INSTAGRAM_TITLE.VIDEO || title === INSTAGRAM_TITLE.STORY));

  const canTranscribe = useHasFeature(FEATURE.HAS_REQUEST_TRANSCRIPT_FEATURE);

  const hasTranscriptionFeatures = episode_id && canTranscribe;

  const episodeCanBeTranscribed =
    !episode_has_transcript && isTiktokOrInstagramOrNonText;

  const showRequestTranscription =
    hasTranscriptionFeatures && episodeCanBeTranscribed;

  if (!showRequestTranscription) {
    return null;
  }
  return (
    <Component
      onClick={handleRequestTranscript}
      disabled={
        loading || (transcriptionInProgress && isTiktokOrInstagramOrNonText)
      }
      {...rest}
    >
      {transcriptionInProgress
        ? L.MENTIONS_TRANSCRIBE_IN_PROGRESS
        : L.MENTIONS_TRANSCRIBE_EPISODE}
    </Component>
  );
};

export default TranscribeEpisode;
